import React, { useState } from "react";
import EnquiryResult from "./EnquiryResult";
import EnquiryForm from "./EnquiryForm";
import axios from "axios";

const Enquiry = () => {
  const BaiscUrl = `${process.env.REACT_APP_BACKEND}?circle=${process.env.REACT_APP_BACKEND_CIRCLE}&search=`;
  const [FilterResult, setFilterResult] = useState(null);
  const [voterData, setVoterData] = useState({});

  const submitHandler = async (e) => {
    const numberWord = e.split(" ").length;
    if (numberWord >= 2) {
      try {
        const response = await axios.get(`${BaiscUrl}${e}`);
        const results = response.data;
        setVoterData({
          /* name: results[0].FirstName
            ? results[0].FirstName.trim() +
              " " +
              results[0].SecondName.trim() +
              " " +
              results[0].ThirdName.trim() +
              " " +
              results[0].ForthName.trim() +
              " " +
              results[0].Familly.trim()
            : null, */
            name: results[0].full_name ? results[0].full_name : null,

          aldaayira: results[0].CircleName
            ? results[0].CircleName.trim()
            : null,
          committee: results[0].LgnaNumber ? results[0].LgnaNumber : null,
          number_of_registration: results[0].Code ? results[0].Code : null,
          area: results[0].RegionName ? results[0].RegionName.trim() : null,
          status: results[0].CodeStatus ? results[0].CodeStatus : null,
          school: results[0].SchoolName ? results[0].SchoolName : null,
          Y: results[0].y_geo ? results[0].y_geo : null,
          X: results[0].x_geo ? results[0].x_geo : null,
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("الرجاء ادخال الاسم ثلاثي");
    }
  };

  const filterHandler = async (filterValue) => {
    if (filterValue !== null && filterValue !== "") {
      const numberWord = filterValue.split(" ").length;
      if (numberWord > 2) {
        try {
          const response = await axios.get(`${BaiscUrl}${filterValue}`);
          const results = response.data;
          setFilterResult(
           /*  results.map(
              (item) =>
                item.FirstName +
                " " +
                item.SecondName +
                " " +
                item.ThirdName +
                " " +
                item.ForthName +
                " " +
                item.Familly */
                response.data.map((item) => item.full_name)
            );
          
        } catch (error) {
          console.log(error);
        }
      } else {
        setFilterResult(null);
      }
    } else {
      setFilterResult(null);
    }
  };
  

  return (
    <React.Fragment>
      <div className="">
        <EnquiryForm
          submitHandler={submitHandler}
          filterResult={FilterResult}
          filterHandler={filterHandler}
        />
        <EnquiryResult result={voterData} />
      </div>
    </React.Fragment>
  );
};

export default Enquiry;
